import Script from "next/script";

const NasaVariable = (props) => {
  const { type, value } = props;
  // 네이버 분석 전환 스크립트
  // type: 전환 타입
  // value: 전환 가치

  return (
    <>
      <Script id="nasa_variable" strategy="afterInteractive">
        {`
        if (!wcs_add) var wcs_add={};
        wcs_add["wa"] = "s_53d3817a0ea3";
        var _nasa={};
        if (window.wcs) {
          _nasa["cnv"] = wcs.cnv(${type},${value});
        wcs_do(_nasa);
        }
        var _nasa={};
        `}
      </Script>
    </>
  );
};
export default NasaVariable;
